import * as React from "react";
import { defineCustomTags } from "sb-helpers";
defineCustomTags("sb-resp-popup-overlay");
export class Overlay extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.html = React.createRef();
        this.onTouchMove = this.props.onTouchMove.bind(this);
    }
    componentDidMount() {
        if (this.html.current) {
            this.html.current.addEventListener("touchmove", this.onTouchMove, false);
        }
    }
    componentWillUnmount() {
        if (this.html.current) {
            this.html.current.removeEventListener("touchmove", this.onTouchMove, false);
        }
    }
    render() {
        return (React.createElement("sb-resp-popup-overlay", { ref: this.html, onClick: this.props.onClick }));
    }
}
//# sourceMappingURL=Overlay.js.map